import {
    type ComponentLayoutObject,
    type CompStructure,
    type Pointer,
    type PS,
    SYSTEM_CONTAINER_TYPE
} from '@wix/document-services-types'
import slots from '../../slots/slots'

const defaultLayout: Partial<ComponentLayoutObject> = {
    containerLayout: {
        type: 'GridContainerLayout',
        rows: [
            {
                type: 'MinMaxSize',
                min: {
                    type: 'spx',
                    value: 330
                },
                max: {
                    type: 'auto'
                }
            }
        ],
        columns: [
            {
                type: 'fr',
                value: 1
            }
        ]
    },
    spx: {
        refWidth: 1280,
        resolverType: 'scale'
    },
    componentLayout: {},
    // @ts-ignore
    itemLayout: {},
    type: 'SingleLayoutData'
}

const systemContainerDefinition: CompStructure = {
    componentType: SYSTEM_CONTAINER_TYPE,
    layouts: defaultLayout
}

export const populateSlotWithSystemContainer = (
    ps: PS,
    componentRef: Pointer,
    slotName: string,
    innerElementPath?: string[],
    componentDefinition: CompStructure = systemContainerDefinition
): void => {
    const componentToAddPointer = slots.getComponentToAddPointer(ps, componentRef)

    if (innerElementPath) {
        ps.extensionAPI.innerElements.setInnerElementSlots(
            componentToAddPointer,
            componentRef,
            innerElementPath,
            slotName,
            componentDefinition
        )
    } else {
        slots.populate(ps, componentToAddPointer, componentRef, slotName, componentDefinition)
    }
}
